module.exports = __webpack_public_path__ + "static/media/02PerformancePhotos.3114b075.jpeg";